import AssociatedPropertySelector from './containers/AssociatedPropertySelectorContainer'

export default AssociatedPropertySelector
